export const TV_PLAN_CARDS = {
  GLOBO_PLAY: 'GLOBO_PLAY',
  GLOBO_PLAY_DEFAULT_WITH_ADS: 'GLOBO_PLAY_DEFAULT_WITH_ADS',
  GLOBO_PLAY_DEFAULT: 'GLOBO_PLAY_DEFAULT',
  GLOBO_PLAY_PREMIUM: 'GLOBO_PLAY_PREMIUM',
  PREMIERE: 'PREMIERE',
  TELECINE: 'TELECINE',
  GLOBO_PLAY_MAIS_CANAIS: 'GLOBO_PLAY_MAIS_CANAIS',
  GIGA_TV: 'GIGA_TV',
  EXA_SECURITY: 'EXA_SEGURANCA',
  EXA_CLOUD: 'EXA_CLOUD',
  SUPERPLAYER_EXITLAG: 'SUPERPLAYER_EXITLAG',
  YOUTUBE: 'YOUTUBE_PREMIUM',
}

export const TV_PLAN_CARD_GIGA_TV_PREFIX = 'GIGA'

export const TV_PLAN_CARD_VALUES = [
  TV_PLAN_CARDS.GLOBO_PLAY,
  TV_PLAN_CARDS.GLOBO_PLAY_DEFAULT_WITH_ADS,
  TV_PLAN_CARDS.GLOBO_PLAY_DEFAULT,
  TV_PLAN_CARDS.GLOBO_PLAY_PREMIUM,
  TV_PLAN_CARDS.YOUTUBE,
  TV_PLAN_CARDS.PREMIERE,
  TV_PLAN_CARDS.TELECINE,
  TV_PLAN_CARDS.GLOBO_PLAY_MAIS_CANAIS,
  TV_PLAN_CARDS.GIGA_TV,
  TV_PLAN_CARDS.EXA_SECURITY,
  TV_PLAN_CARDS.EXA_CLOUD,
  TV_PLAN_CARDS.SUPERPLAYER_EXITLAG,
]

export const TV_PLAN_EVENTS = {
  [TV_PLAN_CARDS.GLOBO_PLAY]: 'CLICK_ON_GLOBOPLAY_LINK',
  [TV_PLAN_CARDS.GLOBO_PLAY_DEFAULT_WITH_ADS]: 'CLICK_ON_GLOBO_PLAY_DEFAULT_WITH_ADS_LINK',
  [TV_PLAN_CARDS.GLOBO_PLAY_DEFAULT]: 'CLICK_ON_GLOBO_PLAY_DEFAULT_LINK',
  [TV_PLAN_CARDS.GLOBO_PLAY_PREMIUM]: 'CLICK_ON_GLOBO_PLAY_PREMIUM_LINK',
  [TV_PLAN_CARDS.YOUTUBE]: 'CLICK_ON_YOUTUBE_LINK',
  [TV_PLAN_CARDS.PREMIERE]: 'CLICK_ON_SVA_TELECINE',
  [TV_PLAN_CARDS.TELECINE]: 'CLICK_ON_PREMIERE_LINK',
  [TV_PLAN_CARDS.GLOBO_PLAY_MAIS_CANAIS]: 'CLICK_ON_SVA_GLOBO_PLAY_MAIS_CANAIS',
  [TV_PLAN_CARDS.GIGA_TV]: 'CLICK_ON_SVA_GIGA_TV',
  [TV_PLAN_CARDS.EXA_SECURITY]: 'CLICK_ON_EXA_SEGURANÇA_LINK',
  [TV_PLAN_CARDS.EXA_CLOUD]: 'CLICK_ON_EXA_CLOUD_LINK',
  [TV_PLAN_CARDS.SUPERPLAYER_EXITLAG]: 'CLICK_ON_SUPERPLAYER_EXITLAG_LINK',
}
